import { Component, OnInit, Input, Output, Inject, EventEmitter } from '@angular/core';
import { fadeInAnimation } from '../../animations/fade-in.animation';

import { ApplicationChangerItem } from './application-changer-item';
import { ApplicationChangerProvider } from './application-changer.provider';


export class ApplicationChangerComponent {

    
    public onLogout : EventEmitter<void> = new EventEmitter<void>();

    public applications : ApplicationChangerItem[];

    constructor(private provider : ApplicationChangerProvider){
      provider.getApplications()
        .takeWhile(() => this.applications == null)
        .subscribe((apps: ApplicationChangerItem[]) => {
        this.applications = apps;
      });
    }

    onApplicationChange(app : ApplicationChangerItem) {
      console.log(app);
    }

    public clickLogout() : any {
      this.onLogout.emit();
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[leaf-application-changer]',
  template:  `
  <div class="btn-group" dropdown *ngIf="applications" [@fadeInAnimation]>
    <button dropdownToggle type="button" class="btn btn-primary dropdown-toggle">
      <i class="fa fa-cloud"></i>&nbsp; {{ 'leaf.application-changer.applications' | translate }} <span class="caret"></span>
    </button>
    <ul *dropdownMenu class="dropdown-menu" role="menu">
      <li role="menuitem" *ngFor="let app of applications" (click)="onApplicationChange(app)">
          <a class="dropdown-item">{{app.name}}</a>
      </li>
      <li class="divider"></li>
      <li role="menuitem" (click)="clickLogout()">
          <a class="dropdown-item"><i class="fa fa-sign-out"></i>&nbsp; {{ 'leaf.common.signout' | translate }}</a>
      </li>
    </ul>
  </div>
  `,
  animations: [fadeInAnimation]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ApplicationChangerProvider, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onLogout': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
